import { render, staticRenderFns } from "./overtimeEdit.vue?vue&type=template&id=5671a8b1&scoped=true"
import script from "./overtimeEdit.vue?vue&type=script&lang=js"
export * from "./overtimeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671a8b1",
  null
  
)

export default component.exports